import { BaseMapper } from '@ps/utils';
import { QualificationCategory } from '@ps/survey-utils';

import { QualificationCategoryDto } from '../dtos/advanced-qualification.dto';

export class QualificationCategoryMapper extends BaseMapper<
  QualificationCategoryDto,
  QualificationCategory
> {
  public fromDto(dto: QualificationCategoryDto): QualificationCategory {
    return {
      id: dto.id,
      label: dto.label,
    };
  }
}
